import noop from 'lodash/noop'
import { icons } from '@ggs/ui'
import { cn } from '@ggs/utils'

import './WishlistButton.scss'

/**
 * @typedef {object} WishlistButtonProps
 * @property {boolean=} active - State of wishlist button
 * @property {string=} className - Additional custom classes
 * @property {string=} label - label for wishlist button
 * @property {function=} onClick - onClick action for wishlist button
 * @property {('light'|'dark')=} style - light or dark style
*/

/**
 *
 * @param {WishlistButtonProps} props
 * @return {JSX.Element}
 */
const WishlistButton = (props) => {
  const {
    active = false,
    className = '',
    label = '',
    onClick = noop,
    style = '',
    ...extraProps
  } = props

  return (
    <button
      type="button"
      className={cn('wishlist-btn', active && 'wishlist-btn--active', label && 'wishlist-btn--with-label', className)}
      data-style={style}
      onClick={() => onClick()}
      {...extraProps}
    >
      {icons.HeartPlus}
      {label && (<span className="wishlist-btn__label">{label}</span>)}
    </button>
  )

}

export default WishlistButton
